import { type FunctionComponent } from 'react';
import { type DynamicYieldTemplate } from '../../../types/home.types';

export const HomeDynamicYield: FunctionComponent<DynamicYieldTemplate & { automationHook?: string }> = ({ name, automationHook }) => {
	return <div id={name} data-testid="dyElement" data-automation={automationHook} />;
};
